<template>
  <v-card class="elevation-0">
    <v-card-text class="pt-0">
      <v-flex v-if="!loading" >
        <v-layout row wrap>
          <v-flex>
            <v-card class="elevation-0">
              <v-card-title primary-title>
                <span class="title">Bitstamp Fund</span>
              </v-card-title>
              <v-card-text class="pt-0">
                <v-expansion-panel expand v-model="expand">
                  <v-expansion-panel-content v-for="account in sortedAccount" :key="account.account_id">
                    <div slot="header">
                      <div style="display: flex" class="align-center pr-4">
                        <v-icon
                          v-html="'mdi-checkbox-blank-circle'"
                          small
                          :color="getStatusColor(account.success)"
                          class="mr-4"
                        />
                        <span class="body-2">{{ account.account_name }}</span>
                        <div class="spacer"></div>
                        <div v-if="!account.error && account.btc !== false" :class="[
                          'd-inline-block',
                          'text-xs-right'
                        ]">
                          {{ account.btc | bitcoin }}
                        </div>
                        <div v-if="!account.error && account.usd !== false" :class="[
                          'd-inline-block',
                          'text-xs-right',
                          account.incorrect ? 'red--text' : undefined
                        ]" style="width: 130px">
                          {{ account.usd | dollar }}
                        </div>
                      </div>
                    </div>
                    <div class="pa-3 grey lighten-4">
                      <v-layout row wrap>
                        <template v-if="!account.error">
                          <v-flex v-if="!account.balances.length" d-flex xs12 class="text-xs-center">
                            <span class="grey--text">
                              <i>Empty</i>
                            </span>
                          </v-flex>
                          <v-flex v-else v-for="balance in account.balances" :key="balance.currency" d-flex xs12 sm6 md4>
                            <v-card class="elevation-4 ma-2 mb-3">
                              <v-card-title primary-title>
                                <h1 class="primary--text">{{ balance.currency }}</h1>
                              </v-card-title>
                              <v-card-text class="pt-0">
                                <div>
                                  <span class="grey--text body-2">Available: </span>
                                  <span>{{balance.available}}</span>
                                </div>
                                <div>
                                  <span class="grey--text body-2">Balance: </span>
                                  <span>{{balance.balance}}</span>
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </template>
                        <v-flex v-if="account.error" d-flex xs12>
                          <v-alert outline color="error" icon="warning" :value="true" class="ma-2 white">
                            {{ account.error }}
                          </v-alert>
                        </v-flex>
                      </v-layout>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex>
            <FundMove :accounts="accounts"  />
          </v-flex>
        </v-layout>
      </v-flex>
    </v-card-text>
    <v-fade-transition>
      <v-progress-linear v-if="loading" indeterminate height="3" class="ma-0" style="position: absolute; bottom: -1px; left: 0; right: 0;"></v-progress-linear>
    </v-fade-transition>
  </v-card>
</template>

<script>
import FundMove from './FundMove';

export default {
  props: {
    accounts: { type: Array, required: false }
  },
  data() {
    return {
      expand: []
    };
  },
  computed: {
    loading() {
      return !this.accounts;
    },
    sortedAccount() {
      function compare(a, b) {
        if (a.sorter < b.sorter) return -1
        if (a.sorter > b.sorter) return 1
        return 0
      }
      return this.accounts.sort(compare);
    }
  },
  watch: {
    accounts(accounts) {
      if (accounts) {
        this.expand = accounts.map(account => {
          return (
            account.expand || !account.success || this.accounts.length === 1
          );
        });
      }
    }
  },
  components: {
    FundMove
  },
  methods: {
    getStatusColor(value) {
      if (value === null) return null;
      return value ? 'success' : 'error'
    }
  }
};
</script>
